import React, { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Header, Navbar, Sidebar } from 'src/components/elements'
import { Loader } from 'src/components/ui'
import { useGetUserQuery } from 'src/redux/api'
import { isSignedOutError } from 'src/helpers/authState'
import ServerUnavailable from 'src/components/elements/server-unavailable/ServerUnavailable'
import { SidebarProvider, useSidebar } from 'src/contexts/SidebarContext'
import clsx from 'clsx'

const MainFullLayoutContent = () => {
  const { data: user, isLoading, error, refetch } = useGetUserQuery(undefined)
  const { collapsed } = useSidebar()

  if (isLoading) return <Loader />
  // Only a real sign-out leads to /login. A failed refetch keeps the cached
  // user on the page; a server that is down on the first load gets a retry.
  if (!user && (!error || isSignedOutError(error)))
    return (
      <Navigate to="/login" state={{ from: window.location.pathname + window.location.search }} />
    )
  if (!user) return <ServerUnavailable onRetry={refetch} />

  return (
    <>
      <div
        className={clsx(
          'transition-all duration-300 max-md:[--bottom-bar-h:var(--navbar-h)] max-md:[--top-bar-h:var(--header-h)]',
          collapsed ? 'md:pl-[5rem]' : 'md:pl-[23rem]',
        )}
      >
        <div className="fixed top-0 left-0 z-20 h-full overflow-y-auto sidebar-scroll md:block hidden">
          <Sidebar />
        </div>
        {/* dvh on phones: 100vh counts the hidden browser toolbar. On phones
            the page is exactly the room between the fixed header and the
            menu; the chat and the chat list scroll inside it. */}
        <main className="relative flex flex-col bg-page pt-[var(--header-h)] pb-[var(--navbar-h)] md:py-0 h-screen max-md:supports-[height:100dvh]:h-dvh">
          <div className="flex flex-col gap-4 md:px-4 md:p-0 md:pt-9 relative h-full max-md:min-h-0">
            <Header />
            {/* Suspense wraps the routed page only, like MainLayout. */}
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
            <Navbar className="md:hidden" />
          </div>
        </main>
      </div>
    </>
  )
}

const MainFullLayout = () => {
  return (
    <SidebarProvider>
      <MainFullLayoutContent />
    </SidebarProvider>
  )
}

export default MainFullLayout
